import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'
import { filter } from 'lodash'

// initial state
const state = {
  all: {},
}

// getters
const getters = {
  getUserById: (state) => (id) => {
    return state.all[id]
  },
  getAll: (state) => () => {
    if (state.all === null) {
      return []
    }
    return Object.values(state.all)
  },
  getUserKeyByEmail: (state) => (email) => {
    if (!email) return undefined

    let keys = Object.keys(state.all)
    let matchedKey = filter(keys, function (o) {
      return state.all[o].email === email
    })
    return matchedKey[0]
  },
  haveUnapprovedUsers: (state) => () => {
    let unapprovedUsers = filter(state.all, function (o) {
      return !o.approved && !o.ignore
    })
    return unapprovedUsers.length > 0
  },
}

// actions
const actions = {
  bindUsers: firebaseAction(context => {
    return context.bindFirebaseRef('all', db.ref('users'))
  }),
  toggleApproved: ({ commit }, { userKey, approved }) => {
    db.ref(`users/${userKey}`).update({ approved: approved })
  },
  toggleIgnore: ({ commit }, { userKey, ignore }) => {
    db.ref(`users/${userKey}`).update({ ignore: ignore })
  },
  toggleVolumeControl: ({ commit }, { userKey, volumeControl }) => {
    db.ref(`users/${userKey}`).update({ volumeControl: volumeControl })
  },
}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
